<template>

    <div>
        <v-stepper v-model="currStep">
            <v-stepper-header>
                <v-spacer></v-spacer>
                <v-stepper-step :complete="currStep > 1" step="1">ค้นหาสมาชิก</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="currStep > 2" step="2">นัดหมาย</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="currStep > 3" step="3">ยืนยัน</v-stepper-step>
                <v-spacer></v-spacer>
                <v-btn @click="closeDialog" class="ma-1" text><v-icon>close</v-icon></v-btn>
            </v-stepper-header>

            <v-stepper-items>
                <v-stepper-content step="1">
                    <FragmentSearchMember ref="searchmember" 
                    @onSelectMember="nextStepOnSelectMember" 
                    :createmember="createMember"
                    :station_code="station_code"
                    ></FragmentSearchMember>
                </v-stepper-content>
                <v-stepper-content step="2">
                    <v-card-title style="padding-top:0.5em;" align="left">
                        ชื่อสมาชิก : {{ currMember ? currMember.display_name : "" }}
                    </v-card-title>
                    <FragmentSelectDateGroupTime 
                        ref="dategrouptime" 
                        @ongroup="(group) => {currGroupId = group.group_id;currGroupName = group.group_name}" 
                        @ondate="(date) => currDate = date" 
                        @ontimestart="(timestart) => currTimestart = timestart" 
                        @ontimeend="(timeend) => currTimeend = timeend" 
                        @onextranote="(extranote) => currExtranote = extranote"
                        :station_code="station_code"
                    ></FragmentSelectDateGroupTime>
                    <v-row>
                        <v-col class="text-right">
                            <v-btn color="primary" @click="previousStep" :disabled="disabled_step1">ย้อนกลับ</v-btn> &nbsp;
                            <v-btn color="primary" @click="nextStep" :disabled="!isReady">ตกลง</v-btn>
                        </v-col>
                    </v-row>
                </v-stepper-content>
                <v-stepper-content step="3">
                    <FragmentConfirmAppointment 
                        :member="currMember"
                        :station_code="station_code"
                        :group_id="currGroupId"
                        :group_name="currGroupName"
                        :date="currDate"
                        :timestart="currTimestart"
                        :timeend="currTimeend"
                        :extranote="currExtranote"
                        @onConfirmAppointment="nextStepOnConfirmAppointment" 
                        @onBackClick="previousStep"
                    >
                    </FragmentConfirmAppointment>
                </v-stepper-content>
            </v-stepper-items>
        </v-stepper>
    </div>

    
</template>

<script>
import FragmentSelectDateGroupTime from './FragmentSelectDateGroupTime'
import FragmentConfirmAppointment from './FragmentConfirmAppointment'
import FragmentSearchMember from './FragmentSearchMember'

export default {
    props: ['station_code','disabled_step1'],
    components: {
        FragmentSearchMember,
        FragmentSelectDateGroupTime,
        FragmentConfirmAppointment
    },
    data: () => ({
        currStep: 1,
        currMember: null,
        currDate: null,
        currGroupId: null,
        currGroupName: null,
        currTimestart: null,
        currTimeend: null,
        currExtranote: null
    }),
    computed: {
        isReady(){
            return this.currDate != null && this.currDate != undefined
            && this.currGroupId != null && this.currGroupId != undefined
            && this.currTimestart != null && this.currTimestart != undefined
            && this.currTimeend != null && this.currTimeend != undefined
        }
    },
    methods: {
        closeDialog() {
            this.$emit('onclosed');
        },
        createMember() {
            this.$emit('onclosed');
            this.$emit('oncreatemember');
        },
        nextStepOnSelectMember(member){
            this.currMember = member
            
            this.currStep++;
        },
        nextStep(){
            this.currStep++;
        },
        nextStepOnConfirmAppointment() {
            this.reset()
            this.closeDialog();
            this.$emit('onsuccess');
        },
        previousStep() {
            this.currStep--;
        },
        reset(){
            this.currStep = 1;
            this.$refs.searchmember.reset()
            this.$refs.dategrouptime.reset()
            this.currMember = null
            /*this.currDate = null
            this.currGroupId = null
            this.currGroupName = null
            this.currTimestart = null
            this.currTimeend = null*/
        }
    }
    
}
</script>